// @flow

const forbiddenKeys = ['companyID', 'companyName', 'houseNo', 'email', 'contactStreet', 'contactHouseNo', 'birthNumber',
                       'firstName', 'lastName', 'phoneNumber', 'vin', 'regPlate', 'street', 'technicalCardNo']

const logDataSerializer = (data: Object) => {
  if (data && typeof data === 'object') {
    const dataToMap = Array.isArray(data) ? data : Object.keys(data)
    dataToMap.map(key => {
      if (forbiddenKeys.includes(key)) {
        data[key] = '***secure***'
      } else if (typeof data[key] === 'object') {
        logDataSerializer(data[key])
      }
    })
    return data
  }
  return {}
}

export default logDataSerializer
